let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bM8SD")).then(() => parcelRequire('hNqd6'));